import React from 'react'
import {Account, LeaseApplication} from '../../types/app-types'
import LoaderInline from '../common/LoaderInline'
import Alert from '../common/Alert'
import {Link} from 'react-router-dom'

interface LeaseApplicationListCardProps {
  leaseApplicationsQuery: {
    data?: LeaseApplication[]
    isLoading: boolean
  }
}

interface LeaseApplicationListItemProps {
  leaseApplication: LeaseApplication
}

const LeaseApplicationListItem = ({
  leaseApplication
}: LeaseApplicationListItemProps) => {
  const {id, leasePropertyId, leaseUnit, applicationStatus} = leaseApplication
  return (
    <li key={id} className="w-full mb-1">
      <Link
        to={`/lease-application/${id}`}
        className="flex link link-primary no-underline"
      >
        <div
          className="account-list-item bg-gray-100 text-gray-800 font-medium
        rounded-lg p-2 w-full h-30 cursor-pointer border border-gray-200 hover:bg-gray-300 relative"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 md:grid-rows-2 sm:grid-cols-1 sm:grid-rows-4 gap-1 p-1">
            <div className="font-bold top-0 left-0 whitespace-nowrap">
              {leasePropertyId}
            </div>
            <div className="md:text-right">Application ID: {id}</div>
            <div className="text-gray-700 md:justify-self-start md:align-self-end flex justify-between items-end">
              Unit {leaseUnit}
            </div>
            {/* <div className="md:text-right md:justify-self-end md:align-self-end flex justify-between">
            Status: {status}
          </div> */}
          </div>
        </div>
      </Link>
    </li>
  )
}

const LeaseApplicationListCard = ({
  leaseApplicationsQuery
}: LeaseApplicationListCardProps) => {
  const isLoading = leaseApplicationsQuery?.isLoading
  const leaseApplications = leaseApplicationsQuery?.data

  return (
    <div className="card-default w-full">
      <div className="card-body-default">
        <h1 className="card-header">Applications</h1>

        {isLoading ? <LoaderInline text="Loading lease applications..." /> : ''}

        {!isLoading && leaseApplications?.length ? (
          <ul>
            {leaseApplications.map(leaseApplication => {
              return (
                <LeaseApplicationListItem
                  key={leaseApplication.id}
                  leaseApplication={leaseApplication}
                />
              )
            })}
          </ul>
        ) : (
          ''
        )}

        {!isLoading && (!leaseApplications || !leaseApplications?.length) ? (
          <p>No lease applications found</p>
        ) : (
          ''
        )}
      </div>
    </div>
  )
}

export default LeaseApplicationListCard
